import { createReduxAsyncThunk } from 'shared/utils';

import { driversAPI } from '../../api';

import { DRIVERS_STATE } from '../../constants';

import { GetFilteredDriverFuelAssignmentsFilter } from '../../types';

export const getDriverFilteredFuelAssignments = createReduxAsyncThunk(
  `${DRIVERS_STATE}/getDriverFilteredFuelAssignments`,
  async (filter: GetFilteredDriverFuelAssignmentsFilter) => {
    const { data } = await driversAPI.getFilteredDriverFuelAssignments(filter);
    return { data, filter };
  }
);
